import React from 'react';
import { Link } from 'react-router-dom';
import { NavToggle } from '../toggle';
import {
  MenuWrapper,
  MenuListWrapper,
  DataImprintWrapper,
  MenuHeader,
  MenuList,
  MenuListItem,
  MenuTitle,
} from './style';
import { FlexCol, FlexRowCenter, Text } from '../misc';
import { FloatingButton } from '../buttons';

const Nav = ({ onNavClose, logout, togglePrices, showPrices }) => (
  <MenuWrapper>
    <MenuHeader>
      <div>
        <NavToggle onClick={onNavClose} isExpanded={true} />
      </div>
      <MenuTitle>Menu</MenuTitle>
    </MenuHeader>
    <MenuListWrapper>
      <MenuList>
        <Link to="/">
          <MenuListItem
            onClick={() => {
              setTimeout(() => onNavClose(), 300);
            }}
          >
            <span>Shop</span>
          </MenuListItem>
        </Link>
        <MenuListItem
          onClick={() => {
            togglePrices();
            setTimeout(() => onNavClose(), 100);
            return;
          }}
        >
          <span>Preise {showPrices ? 'ausblenden' : 'einblenden'}</span>
        </MenuListItem>
        <MenuListItem
          onClick={() => {
            window.location.href =
              'https://drive.google.com/drive/folders/1sP7VGLNoEa3XPIQCC_VCJ7f6ZueJf0QB?usp=sharing';
          }}
        >
          <span>Download-Bereich Werbematerial</span>
        </MenuListItem>
      </MenuList>
      <Link to="/login">
        <FlexRowCenter
          style={{
            marginTop: '32px',
            padding: '0 16px',
          }}
        >
          <FloatingButton
            style={{}}
            onClick={() => {
              onNavClose();
            }}
          >
            Logout
          </FloatingButton>
        </FlexRowCenter>
      </Link>
      <FlexCol
        css={`
          margin-top: auto;
          padding: 0 16px;
        `}
      >
        <DataImprintWrapper>
          <a
            href="https://www.libuda-optik.de/impressum#impressum"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Text>Impressum</Text>
          </a>
          <a
            href="https://www.libuda-optik.de/impressum#agb"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Text>AGBs</Text>
          </a>
          <a
            href="https://www.libuda-optik.de/impressum#datenschutz"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Text>Datenschutz</Text>
          </a>
        </DataImprintWrapper>
        <DataImprintWrapper>
          <Text>Copyright © Libuda Optik e.K.</Text>
        </DataImprintWrapper>
      </FlexCol>
    </MenuListWrapper>
  </MenuWrapper>
);

export default Nav;



// WEBPACK FOOTER //
// ./src/components/nav/index.js